import { createContext, useMemo, useContext } from 'react';
import { type GetBankQuery } from '../../../api/queries/getBank';
import { useBankDetailFromOption } from './shared/useBankOptions';

export const FinanceProductDetailContext = createContext<{
    bank?: GetBankQuery['bank'];
}>(null);

export type FinanceProductDetailProviderProps = {
    children: React.ReactNode;
    bankId?: string;
};

export const FinanceProductDetailProvider = ({ bankId, children }: FinanceProductDetailProviderProps) => {
    const bank = useBankDetailFromOption(bankId);

    const context = useMemo(() => ({ bank }), [bank]);

    return <FinanceProductDetailContext.Provider value={context}>{children}</FinanceProductDetailContext.Provider>;
};

export const useFinanceProductDetailContext = () => {
    const context = useContext(FinanceProductDetailContext);

    if (!context) {
        throw new Error('useFinanceProductDetailContext must be used within a FinanceProductDetailProvider');
    }

    return context;
};
